/** @format */

import { fromJS } from 'immutable';

const INITIAL_STATE = fromJS({
  isShowing: false,
  isLoading: false,
  isDone: false,
  logs: [],
  refId: null,
  error: ''
});

export default function subscriptionAlarmHistoryReducer(
  state = INITIAL_STATE,
  action
) {
  switch (action.type) {
    case 'GET_ALARM_HISTORY_STARTED': {
      return INITIAL_STATE.set('isShowing', true).set('isLoading', true);
    }
    case 'HIDE_SUBSCRIPTION_ALARM_HISTORY_MODAL': {
      return INITIAL_STATE;
    }
    case 'GET_ALARM_HISTORY_DONE': {
      return state.set('error', '').set('refId', action.payload.refId);
    }
    case 'UPDATE_COMMAND_STATE': {
      const { logLines } = action.payload?.data || {};
      return state
        .set('error', '')
        .set('isLoading', false)
        .set('isDone', true)
        .set('logs', fromJS(logLines));
    }
    case 'GET_ALARM_HISTORY_FAILED': {
      return state.set('isLoading', false).set('error', action.payload.msg);
    }
    default: {
      return state;
    }
  }
}
